import React from 'react';
import { connect } from 'react-redux';
import { closeAnnulerClotureDialog } from 'store/common/commonActions';
import { annulerCloture } from 'store/reclamation/reclamationsActions';
import AnnulerClotureDialog from './AnnulerClotureDialog';


class AnnulerClotureDialogContainer extends React.Component {
    handleClose = () => {
        const { onClose } = this.props;

        onClose();
    }

    handleClickSave = () => {
        const { annulerCloture, reclamationId } = this.props;        

        annulerCloture(reclamationId);
    }

    render() {
        const { open, reclamationId } = this.props;        

        return (
            <AnnulerClotureDialog
                open={open}
                reclamationId={reclamationId}
                onClose={this.handleClose}
                onClickSave={this.handleClickSave}
            />
        );
    }
}

const mapStateToProps = state => ({
    open: state.common.annulerClotureDialogOpen,
    reclamationId: state.common.annulerCloture.reclamationId
});


const mapDispatchToProps = dispatch => ({
    annulerCloture: (reclamationId) => dispatch(annulerCloture(reclamationId)),
    onClose: () => dispatch(closeAnnulerClotureDialog())
});


export default connect(mapStateToProps, mapDispatchToProps)(AnnulerClotureDialogContainer);